import {
  selectAccountDetails,
  selectIsAuthenticated
} from 'selectors/account-selector';
import LandingMenuDesktop from './LandingMenuDesktop';
import LandingMenuMobile from './LandingMenuMobile';
import { useAppSelector } from 'store/hooks';

const LandingMenu = () => {
  const { user } = useAppSelector(selectAccountDetails);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return (
    <div className="fixed left-0 top-0 z-50 w-full rounded-t-lg bg-white py-2 shadow md:py-0 lg:py-0">
      <div className="mx-6 px-20 tablet:mx-1 xl:mx-auto">
        <LandingMenuDesktop user={isAuthenticated ? user : null} />
      </div>
      <LandingMenuMobile user={isAuthenticated ? user : null} />
    </div>
  );
};
export default LandingMenu;
